module.exports = __webpack_public_path__ + "static/logo-880f9a7738979be816c5.png";